(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-order-home/assets/javascript/pages/order-home/message/page.js') >= 0) return;  svs.modules.push('/modules/tickets-order-home/assets/javascript/pages/order-home/message/page.js');
"use strict";


const {
  ControlGroup,
  Select,
  Option,
  Form
} = svs.ui.reactForm;
const TextInput = svs.ui.reactFormInputs.TextInput;
const {
  CartBottomSheetContinueSubmit
} = svs.ticketsOrderHome.orderHome.components;
const {
  headerTitle,
  greetings
} = svs.ticketsOrderHome.data.config.orderHome.orderHomeMessage;
const {
  GREETING_LABEL,
  FOOTER_TEXT,
  MAX_GREETING_LENGTH
} = svs.ticketsOrderHome.utils.constants.orderHomeMessage;
const {
  validators
} = svs.ticketsOrderHome.utils;
const {
  PREVIEW_COVERLETTER
} = svs.ticketsOrderHome.routes.ORDER_HOME;
const {
  OrderHomeContext
} = svs.ticketsOrderHome.context;
const {
  useState,
  useRef,
  useContext,
  useEffect
} = React;
const {
  PreviewCard
} = svs.ticketsOrderHome.orderHome.components;
setGlobal('svs.ticketsOrderHome.pages.Message', _ref => {
  let {
    history
  } = _ref;
  const formId = 'order-home-message-form-id';
  const [btnDisabled, setBtnDisabled] = useState(false);
  const {
    state,
    setPersonalGreetingInput,
    setGreetingInput
  } = useContext(OrderHomeContext);
  const mountedRef = useRef(null);
  useEffect(() => {
    mountedRef.current = true;
    return () => {
      mountedRef.current = false;
    };
  }, []);
  const handleGreetingMessageChange = e => {
    if (mountedRef.current) {
      const cursorPosition = e.target.selectionStart - e.target.value.length + state.greetingMessage.length;
      btnDisabled && setBtnDisabled(false);
      setGreetingInput(e.target.value);

      if (e.target.value.length > MAX_GREETING_LENGTH) {
        const nativeValueSetter = Object.getOwnPropertyDescriptor(window.HTMLTextAreaElement.prototype, 'value').set;
        nativeValueSetter.call(e.target, state.greetingMessage);
        const event = new Event('input', {
          bubbles: true
        });
        e.target.dispatchEvent(event);
        requestAnimationFrame(() => {
          e.target.setSelectionRange(cursorPosition, cursorPosition);
        });
      }
    }
  };
  const onSubmitHandler = (e, formData) => {
    e.preventDefault();
    const hasInvalidInputs = Object.values(formData).some(value => !value.isValid);
    if (hasInvalidInputs) {
      setBtnDisabled(true);
      return;
    }
    history.push(PREVIEW_COVERLETTER);
  };
  const onValidate = (_, valid) => {
    mountedRef.current && setBtnDisabled(!valid);
  };
  return React.createElement(Form, {
    id: formId,
    onSubmit: onSubmitHandler,
    onValidate: onValidate
  }, React.createElement("div", {
    className: "order-home-message-page w100 u-flex u-flex-align-items-center u-flex-column bg-white padding-h-2"
  }, React.createElement("div", {
    className: "order-home-message-body w100 f-body"
  }, React.createElement("h2", {
    className: "h2 u-text-center padding-top-3"
  }, headerTitle), React.createElement(PreviewCard, null), React.createElement(ControlGroup, {
    v2: true
  }, React.createElement(Select, {
    label: "Rubrik p\xE5 h\xE4lsningen",
    onChange: e => {
      setPersonalGreetingInput(e.target.value);
    },
    v2: true,
    value: state.personalGreeting
  }, greetings.map(_ref2 => {
    let {
      personalGreetingInput
    } = _ref2;
    const key = personalGreetingInput.replace(' ', '-').toLowerCase();
    return React.createElement(Option, {
      className: state.personalGreeting === personalGreetingInput ? 'order-home-selected-option' : '',
      id: key,
      key: key,
      name: personalGreetingInput,
      value: personalGreetingInput
    }, personalGreetingInput);
  }))), React.createElement("div", {
    className: "u-flex u-flex-column w100 margin-bottom-1"
  }, React.createElement(TextInput, {
    isMultiline: true,
    isRequired: false,
    label: GREETING_LABEL,
    max: MAX_GREETING_LENGTH,
    name: "greetingMessage",
    onChange: handleGreetingMessageChange,
    rows: 9,
    showCharCounter: true,
    validateFn: validators,
    value: state.greetingMessage || ''
  })), React.createElement("div", {
    className: "u-text-center"
  }, React.createElement("p", {
    className: "f-medium"
  }, FOOTER_TEXT)), React.createElement(CartBottomSheetContinueSubmit, {
    disabled: btnDisabled,
    formId: formId
  }))));
});

 })(window);